// @ts-nocheck
import React from "react";
import SheetPageContainer from "./SheetPageContainer";

export default function RosterSheetPage(props: { tokenOverride?: string; embedded?: boolean }) {
  return <SheetPageContainer scope="roster" tokenOverride={props.tokenOverride} embedded={props.embedded} />;
}
